import styled from "styled-components";
import { ReactComponent as Target } from "src/assets/icons/target.svg";

export const StyledTarget = styled(Target)`
    margin-right: 5px; 
    margin-left: 5px;
    width: 16px; 
    height: 16px;
    >g{
        fill: var(--input-font-color);
    }
`;

export const TextName = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: initial;
    max-width: 360px !important;

    span{
        color: var(--input-font-color);
        font-size:0.8rem;
    }
`;

export const Container = styled.div``;
